import { DetailedHTMLProps, HTMLAttributes } from "react";

type ToggleProps = {
  toggled: boolean;
  onClick: () => void;
} & Pick<HTMLAttributes<HTMLDivElement>, "style">;

export default function Toggle({ toggled, onClick, style }: ToggleProps) {
  return (
    <div
      style={{
        position: "relative",
        width: "52px",
        height: "32px",
        borderRadius: "32px",
        backgroundColor: toggled ? "#00bfa5" : "#d8d8d8",
        cursor: "pointer",
        transition: "all 300ms ease",
        ...style,
      }}
      onClick={onClick}
    >
      <div
        style={{
          position: "absolute",
          top: "2px",
          left: toggled ? "22px" : "2px",
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          transition: "all 100ms ease",
          textAlign: "center",
          color: "white",
          userSelect: "none",
          backgroundColor: "#757575",
        }}
      >
        {toggled ? "✓" : "x"}
      </div>
    </div>
  );
}
